/** Keep labels at least 80px apart, including the final bucket's label. */
export function chartTickIndices(count: number, step: number): Set<number> {
  if (count <= 0) return new Set();
  const stride = Math.max(1, Math.ceil(80 / step));
  const last = count - 1;
  const ticks = new Set<number>();
  for (let index = 0; index < last; index += stride) {
    if (last - index >= stride) ticks.add(index);
  }
  ticks.add(last);
  return ticks;
}
